import { IColorGradient } from "src/libs/utilities/colors"
import { Color as ColorScalar } from '@libs/interfaces/layouts'

const getGradientCalc = (prev: IColorGradient, next : IColorGradient, newPos: number) : ColorScalar => {
    // const prevPos : number = parseInt(prev.position)
    // const nextPos : number = parseInt(next.position)
    return chroma.average([ prev.color, next.color ], 'rgb').toString()
}
export default getGradientCalc